import Index from "@/pages/Auth/OnBoard/Index.vue";
const routes = [
    {
        path: "/agency",
        meta:{title:"Agency OnBoard"},
        component: Index,
        children: [
            { path: "/agency/agency-info", name:"agency-info", component: () => import("@/pages/Auth/OnBoard/AgencyInfo.vue"), },
            { path: "/agency/website-info", name:"website-info", component: () => import("@/pages/Auth/OnBoard/WebsiteInfo.vue"), },
            { path: "/agency/agency-address", name:"agency-address", component: () => import("@/pages/Auth/OnBoard/AgencyAddress.vue"), },
        ],
    },
];
export default routes;
